import React, { useEffect, useState } from "react";
import styled, { css } from "react-emotion";
import * as styles from "../newStyles.styles";

import Footer from "../Footer";
import Header from "../Header";
import { getAppsMetadata, getSocialFeed } from "apis";
import AppCard from "./AppCard";
import SocialFeed from "./SocialFeed";
import Grid from "@material-ui/core/Grid";

import { makeStyles } from "@material-ui/core/styles";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const col1 = css`
  text-align: center;
`;

const useStyles = makeStyles(() => ({
  actionArea: {
    borderRadius: 16,
    transition: "0.2s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  card: {
    minWidth: 256,
    borderRadius: 16,
    boxShadow: "none",
    "&:hover": {
      boxShadow: `0 6px 12px 0`,
    },
  },
  content: {
    backgroundColor: "#fff",
    padding: "1rem 1.5rem 1.5rem",
  },
  title: {
    fontSize: "2rem",
    textTransform: "uppercase",
  },
  subtitle: {
    opacity: 0.87,
    marginTop: "2rem",
    fontWeight: 500,
    fontSize: 14,
  },
}));

function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

function MarketPlace({ history }) {
  const [apps, setApps] = useState(null);
  const [feed, setFeed] = useState(null);

  // const styles = useStyles();

  const getApps = async () => {
    try {
      const result = await getAppsMetadata();
      // console.dir(result);
      // result.sort(function (a, b) {
      //   return new Date(b.createdAt) - new Date(a.createdAt);
      // });

      setApps(shuffleArray(result.content));
    } catch (e) {
      console.error(e);
    }
  };
  const getSocialFeedHelper = async () => {
    try {
      const result = await getSocialFeed();
      // console.dir(result);
      // result.sort(function (a, b) {
      //   return new Date(b.createdAt) - new Date(a.createdAt);
      // });

      setFeed(result);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getSocialFeedHelper();
    getApps();
  }, []);

  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <div className={col + " " + col1} style={{ textAlign: "right" }}>
              <styles.H2
                style={{
                  textAlign: "center",
                  margin: "30px 0px",
                  width: "100%",
                }}
              >
                The Mobile360{" "}
                <span className={styles.styledUnderline}>Marketplace</span>
              </styles.H2>
            </div>
            <div
              className={styles.row}
              style={{ margin: "auto", width: "100%" }}
            >
              <div className={styles.col + " " + col1}>
                <styles.H4
                  style={{
                    textAlign: "center",
                    margin: "20px 0px",
                    width: "100%",
                  }}
                >
                  MarketPlace Activity
                </styles.H4>
              </div>
            </div>
            {/* <div className={styles.row}> */}
            <SocialFeed feed={feed} apps={apps} />
            {/* </div> */}
            <div className={styles.row}>
              <styles.H4
                style={{
                  textAlign: "center",
                  margin: "20px 0px",
                  width: "100%",
                }}
              >
                Discover Apps on the MarketPlace
              </styles.H4>
              <p
                style={{
                  textAlign: "center",
                  width: "100%",
                  marginBottom: "20px",
                }}
              >
                Thanks for supporting our local businesses on the Mobile360
                marketplace. Click on any business below to view their app or
                website.
              </p>
              <div className={styles.col}>
                <Grid container spacing={1}>
                  {apps &&
                    apps.map((app) => {
                      if (app.isVerified && app.landingPagePath)
                        return (
                          <Grid item xs={12} sm={6} md={3} key={app.appId}>
                            <a
                              style={{
                                textDecoration: "none",
                              }}
                              href={
                                process.env.NODE_ENV === "prod"
                                  ? "https://www.mobile360.io/" +
                                    app.landingPagePath
                                  : "http://mobile360-qa.s3-website-us-west-1.amazonaws.com/" +
                                    app.landingPagePath
                              }
                              target="_blank"
                            >
                              <AppCard
                                appName={app.appName}
                                logoUrl={app.logoUrl}
                              />
                            </a>
                          </Grid>
                        );
                    })}
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MarketPlace;
